/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        10/01/2020      2416: Flow to NLP change
CHID-2     Usha        20/02/2020      2565:Input validation Issue with gemtriageapi-qa3 GET /api/GemTriage/NLPProcessor/1/fw/ever
 *********************************************************************************/
import { Component } from "@mna/react";
import Modal from "@mna/react-ui/Modal";
import IconX from "assets/icons/x.svg";
import { classnames as cx } from "@mna/react";
import { specialCharactersValidation } from "../commanValidations";
import { Trans } from "react-i18next";
import i18next from "i18next";
import i18n from "./../../../i18n";
let lang;

export default class NLPSymptomSearch extends Component {
  state = {
    showNLPModal: false,
    symptomSearchText: "",
    symptomSearchCalled: false,
    symptomsAdded: [],
  };
  componentDidMount() {
    Modal.setAppElement("#root");
  }
  openModal = () =>
    this.setState({
      showNLPModal: true,
      symptomsAdded: [],
    });
  closeModal = () =>
    this.setState({
      showNLPModal: false,
      symptomSearchText: "",
      symptomSearchCalled: false,
      symptomsAdded: [],
    });
  searchTerm({ text }) {
    if (!text) {
      this.setState({
        symptomSearchText: text,
        symptomSearchCalled: text,
      });
      return;
    }
    const { actions } = this.props;
    let lantest = i18n.language;
    lang = actions.getLanguage(lantest);
    actions.searchSymptomsByText({ text, lang }).then(() =>
      this.setState({
        symptomSearchText: text,
        symptomSearchCalled: text,
      })
    );
  }
  handleInputFocus = () => {
    setTimeout(() => window.scrollTo(0, 0), 3000);
  };

  render() {
    const {
      state,
      state: { symptomSearchResult },
      actions,
      history,
      setState
    } = this.props;
    let typingTimer;
    let TypingInterval = 1000;
    return (
      <div>
        <div>
          <div>
            <div>
              <h2
                className="text-left standby-page-header-title mt-2 mb-3"
                style={{ color: "block" }}
              >
                <Trans i18nKey="findcareoption.NLPSymptom.What_Wrong">
                  What's Wrong?{" "}
                </Trans>{" "}
              </h2>
              <span>
                <Trans i18nKey="findcareoption.NLPSymptom.NLpentersymptomsubheading">
                  Please describe your symptoms (fever, cough, etc.):
                </Trans>{" "}
              </span>
            </div>
            <div className=" standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center ">
              <div style={{ width: "85%" }}>
                <textarea
                  rows="3"
                  className="symptoms"
                  name="symptomSearch"
                  value={this.state.value}
                  onFocus={this.handleInputFocus}
                  autoComplete="off"
                  onChange={(e) => {
                    window.scrollTo(0, 0);
                    const valid = specialCharactersValidation(
                      e.target.value,
                      "validationMsg"
                    );
                    if (!valid) {
                      e.target.value = e.target.value.replace(
                        /[^a-zA-Z ]/g,
                        ""
                      );
                      return;
                    }
                    clearTimeout(typingTimer);
                    typingTimer = setTimeout(
                      (inputvalue) => {
                        this.setState({
                          symptomsAdded: [],
                          symptomSearchText: inputvalue,
                        });
                        for (const key in state.currentSymptomsMap) {
                        var selectedSymptom = state.currentSymptomsMap[key];
                        actions.removeSymptom({
                          symptom: selectedSymptom,
                        });
                      
                        this.setState({
                          symptomsAdded: this.state.symptomsAdded.filter(
                            (common_name) =>
                              common_name !== selectedSymptom.common_name
                          ),
                        });
                      }

                        this.searchTerm({ text: inputvalue });
                      },
                      TypingInterval,
                      e.target.value
                    );
                  }}
                  placeholder={i18next.t("findcareoption.NLPSymptom.search")}
                  autoFocus={!this.state.symptomSearchText}
                ></textarea>{" "}
                <div>
                  <span id="validationMsg" style={{ color: "red" }}></span>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>

        <div>
          <div className="standby_marginbottom_sm ">
            <span>
              {" "}
              <Trans i18nKey="findcareoption.NLPSymptom.Sel_Symptoms">
                {" "}
                Selected Symptoms:{" "}
              </Trans>
            </span>
          </div>
          <ul className="SelectedSymptoms standby-symptom-list">
            {state.currentSymptomsSortedKeys.map((key) => (
              <li
                key={`symptom-added-${state.currentSymptomsMap[key].id}`}
                className="standby-symptom-list-item"
              >
                <button
                  type="button"
                  className="button standby-symptom-button standby-symptom-button-remove"
                  onClick={() => {
                    var selectedSymptom = state.currentSymptomsMap[key];
                    actions.removeSymptom({
                      symptom: selectedSymptom,
                    });
                    this.setState({
                      symptomsAdded: this.state.symptomsAdded.filter(
                        (common_name) =>
                          common_name !== selectedSymptom.common_name
                      ),
                    });
                  }}
                >
                  <div
                    className="icon"
                    style={{ backgroundColor: "rgb(255, 0, 0)" }}
                  >
                    <IconX />
                  </div>
                  <div className="standby-symptom-button-text">
                    {`   ${state.currentSymptomsMap[key].common_name}`}
                  </div>
                </button>
              </li>
            ))}
          </ul>
        </div>
        <hr className="hr" />
        {!this.state.symptomSearchCalled ? (
          <div className="text-bold">
            <Trans i18nKey="findcareoption.NLPSymptom.nil_symptoms">
              No symptoms available
            </Trans>
          </div>
        ) : !symptomSearchResult.length ? null : null}
        {/*CHID-2 Start*/}
        <div className="standby-btn-done">
          <input
            type="submit"
            className={cx(
              "button standby-button standby-button-gradient",
              state.currentSymptomsSortedKeys.length
                ? "standby-button-gradient-green"
                : "standby-button-disabled"
            )}
            value={i18next.t("findcareoption.NLPSymptom.Done")}
            onClick={() => {
              if (state.currentSymptomsSortedKeys.length > 0) {
                state.triageRequest.Symptoms = state.currentSymptomsSortedKeys;
                const primarySymptom =
                  (state.currentSymptomsSortedKeys[0] &&
                    state.currentSymptomsMap[
                      state.currentSymptomsSortedKeys[0]
                    ] &&
                    state.currentSymptomsMap[state.currentSymptomsSortedKeys[0]]
                      .id) ||
                  0;

                actions.setPrimarySymptom({
                  primarySymptom,
                });
                setState({
                  isLoading_PrioritySymptom:false
                })
                history.push(`/find-care-options/${"symptom-priority"}`);
              }
            }}
          />
        </div>
        {/*CHID-2 End*/}
      </div>
    );
  }
}
